var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import CalendarControlled from "./CalendarControlled.js";
var CalendarUncontrolled = function (props) {
    var defaultStartDate = props.defaultStartDate, defaultEndDate = props.defaultEndDate, onDateChange = props.onDateChange;
    var _a = React.useState(defaultStartDate || null), startDate = _a[0], setStartDate = _a[1];
    var _b = React.useState(defaultEndDate || null), endDate = _b[0], setEndDate = _b[1];
    var handleDateChange = function (params) {
        setStartDate(params.startDate);
        setEndDate(params.endDate || null);
        if (onDateChange)
            onDateChange(params);
    };
    return (React.createElement(CalendarControlled, __assign({}, props, { onDateChange: handleDateChange, defaultStartDate: undefined, defaultEndDate: undefined, startDate: startDate, endDate: endDate })));
};
export default CalendarUncontrolled;
